// extracted by mini-css-extract-plugin
module.exports = {"block":"_13377","list":"_939","more":"_9101","arrow":"_7623"};